import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { FilterEntry, FilterType } from "hooks/filters";
import { type Dispatch, useMemo } from "react";

export interface ApplicationClassFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  industry?: Array<AutocompleteData>;
  applicationClass?: Array<AutocompleteData>;
  isDisabled?: boolean;
  t: (key: string) => string;
}

export const ApplicationClassFilter = ({
  value = [],
  onChange,
  industry,
  isDisabled,
  t,
}: ApplicationClassFilterProps) => {
  const filters: Array<FilterEntry> = useMemo(
    () =>
      [
        {
          type: "industry" as FilterType,
          value: industry,
        },
      ].filter((e) => e.value !== undefined && e.value.length > 0),
    [industry],
  );

  return (
    <ColorSearchAutocomplete
      label={t("filter_application_class")}
      example={t("filter_application_class_exmple")}
      type="applicationClass"
      value={value}
      filters={filters}
      limit={500}
      onChange={onChange}
      isDisabled={isDisabled}
    />
  );
};
